import React, { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { useResetRecoilState, useSetRecoilState } from 'recoil';
import { pluginConfig } from './config';
import createConsentHandlers from './utils/createConsentHandlers';
import consentParamsToCategories from './utils/consentParamsToCategories';
import { cookieConsentStateAtom } from './state';
import {
  CROCS_COOKIE_CONSENT_STORAGE_KEY,
  type ConsentParams,
} from './constants';
import normalizeConsentParams from './utils/normalizeConsentParams';
import getCookie from '~/util/getCookie';

const CookieBanner: React.FC = () => {
  const setConsentState = useSetRecoilState(cookieConsentStateAtom);
  const resetRecoilState = useResetRecoilState(cookieConsentStateAtom);

  const consentCookie = getCookie(CROCS_COOKIE_CONSENT_STORAGE_KEY);

  useEffect(() => {
    let initialConsent: ConsentParams | null = null;
    try {
      const existing = localStorage.getItem(CROCS_COOKIE_CONSENT_STORAGE_KEY);

      if (existing) {
        const parsed = JSON.parse(existing) as ConsentParams;
        const normalized = normalizeConsentParams(parsed);
        initialConsent = normalized;
        setConsentState(normalized);
      } else {
        if (consentCookie) {
          // Cookie exists but localStorage does NOT → clear the cookie
          const cookieName = CROCS_COOKIE_CONSENT_STORAGE_KEY;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          resetRecoilState();
        }
      }
    } catch {}

    const handlers = createConsentHandlers({
      storageKey: CROCS_COOKIE_CONSENT_STORAGE_KEY,
      setConsentState,
    });

    void CookieConsent.run(
      pluginConfig({
        COOKIE_CONSENT_STORAGE_KEY: CROCS_COOKIE_CONSENT_STORAGE_KEY,
        ...handlers,
      }),
    );

    // If consent exists in localStorage, sync it into CookieConsent library to prevent any mismatches
    if (initialConsent) {
      const categories = consentParamsToCategories(initialConsent);
      CookieConsent.acceptCategory(categories);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default CookieBanner;
